import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { isStepperEligibleSubmission } from "encamp-shared/src/submissions/wasteSubmissionForms";

/**
 * The feature flag governing a submission's guided stepper flow. The two
 * stepper flags are fully independent: interactive combos (8700-12) are gated
 * by the interactive-stepper flag, every other combo is a document form gated
 * by the document-stepper flag. Shared by the stepper shell's redirect guard
 * and the submissions-list row links so both route on the same decision.
 */
export function stepperFlagForSubmission(
  submissionType?: string | null,
  submissionMethod?: string | null
): FeatureFlagKey {
  return isStepperEligibleSubmission(submissionType, submissionMethod)
    ? FeatureFlagKey.WasteSubmissionStepper
    : FeatureFlagKey.WasteDocumentSubmissionStepper;
}
